const container = {
	maxWidth: '1920px',
	xl: '1632px',
	lg: '1216px',
	md: '928px',
	sm: '688px',
} as const

export default container
